import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import FieldTitle from 'admin-on-rest/lib/util/FieldTitle';

const LongDisabledInput = ({
    input: { value },
    label,
    resource,
    source,
    elStyle,
}) => (
    <TextField
        value={value}
		fullWidth
        floatingLabelText={
            <FieldTitle label={label} source={source} resource={resource} />
        }
        style={elStyle}
        disabled
    />
);

LongDisabledInput.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    elStyle: PropTypes.object,
    input: PropTypes.object,
    addField: PropTypes.bool.isRequired,
};

LongDisabledInput.defaultProps = {
    addField: true,
};

export default LongDisabledInput;



// WEBPACK FOOTER //
// ./src/inputs/LongDisabledInput.js